import Vuex, { Store } from 'vuex';
import { IInventoryState } from '@/store/inventory/inventory.state';
import { inventoryActions } from '@/store/inventory/inventory.actions';
import { inventoryMutations } from '@/store/inventory/inventory.mutations';

export let inventoryStore: Store<IInventoryState>;

export function initializeInventoryStore() {
    inventoryStore = new Vuex.Store<IInventoryState>({
        state: {
            selectedProduct: null,
            selectedLocation: null,
        },
        actions: inventoryActions,
        mutations: inventoryMutations,
    });
    return inventoryStore;
}
